import React, {useEffect, useState} from 'react';

import './ShopTime.css';
import Http from 'Utils/Axios';
import Layout from 'layouts/Default/Default';
import ShopTimeListForm from "./ShopTimeList/ShopTimeListForm";
import ShopTimeAddForm from "./ShopTimeAdd/ShopTimeAddForm";
import {fncgGetUserLoginCheck, fncgGetDbconn} from "Utils/Common/ComCom";
import {DISP_FG, PRM_ID, SEARCH_ID} from "../../../Utils/Common/ComConst";
import {useLocation} from "react-router-dom";

let dispFlg = '0';

function ShopTime({ match, history, location }) {
	const [shop, setShop] = useState('');
	const [data, setData] = useState('');
	const [disp, setDisp] = useState('0');
	const [shoptime, setShopTime] = useState('');
	const [weektime, setWeekTime] = useState('');
	const [interval, setInterval] = useState('');
	const [limit, setLimit] = useState('');
	const [weekcnt, setWeekCnt] = useState('');
	const [user, setUser] = useState('');
	const [urlpram, setUrlPram] = useState('');
	const [dbconn, setDbConn] = useState('');
	const [start, setStart] = useState('0');
	const path = useLocation().pathname;
	const handleSetUser = userData => setUser(userData);
	const handleSetUrlPram = dat => setUrlPram(dat);
	const handleSetDbConn = dat => setDbConn(dat);
	const handleSetStart = dat => setStart(dat);

	/**
	 * 初期処理
	 */
	useEffect(() => {
		//-- 画面情報
		const dispFg = localStorage.getItem(DISP_FG);
		if(dispFg != '' && dispFg != undefined){
			dispFlg = dispFg;
		}else{
			dispFlg = '0';
		}
		let searchID = localStorage.getItem(SEARCH_ID);
		if(searchID != '' && searchID != undefined){
			searchID = JSON.parse(searchID);
			setData(searchID);
		}

		fncgGetDbconn({history, location, handleSetUrlPram, handleSetDbConn, handleSetStart});
	}, [])

	/**
	 * スタッフ情報取得
	 */
	useEffect(() => {
		if(start == '0') return;
		// ログインチェックを行いユーザ情報を返却する
		fncgGetUserLoginCheck({dbconn, urlpram, path, user, handleSetUser, history})
	}, [start])

	/**
	 * 店舗情報取得
	 */
	useEffect(() => {
		if(start == '0' || dbconn.id == '' || dbconn.id == undefined) return;
		let aryData = {
			id : dbconn.id,
		}
		Http.post('api/get-shop',{...aryData}).then(response => {
			setShop(response.data.Shop);
		});
	}, [start])

	/**
	 * 新規登録
	 * @param data
	 */
	const onSubmitMoveAddDisp = data => {
		if(start == '0' || dbconn.id == '' || dbconn.id == undefined) return;
		data.id = dbconn.id;
		setDisp('1');
		setData(data);
		dispFlg = '1';
		localStorage.setItem(DISP_FG, '1');
		window.scrollTo(0, 0);
	}

	/**
	 * 一覧画面表示
	 * @param data
	 */
	const onSubmitMoveListDisp = data => {
		dispFlg = '0';
		setDisp('0');
		setData(data);
		localStorage.setItem(DISP_FG, '0');
		window.scrollTo(0, 0);
	}

	/**
	 * 店舗曜日別時間情報取得
	 * @param data
	 */
	function fncSetShopTimeInfo(data){
		if(data.mode == '1'){
			Http.post('api/init-shoptime',{
				...data
			}).then(response => {
				if (Object.keys(response.data).length > 0) {
					setInterval(response.data.Interval);
					setLimit(response.data.Limit);
					setWeekCnt(response.data.WeekCnt);
					setWeekTime('');
					setShopTime('');
				}
			});
		} else{
			Http.post('api/get-shoptime', {
				...data
			}).then(response => {
				if (Object.keys(response.data).length > 0) {
					setInterval(response.data.Interval);
					setLimit(response.data.Limit);
					setWeekCnt(response.data.WeekCnt);
					setWeekTime(response.data.WeekTime);
					setShopTime(response.data.ShopTime);
				}
			});
		}
	}

	return (
		<>
			{(dispFlg == '0' && shop != '' && shop != undefined && user != '' && user != undefined) &&(
				<Layout headerText="店舗営業時間管理(曜日別一括) -一覧-" _dbconn={dbconn} _user={user}>
					<ShopTimeListForm
						history={history}
						dbconn={dbconn}
						submitMove={onSubmitMoveAddDisp}
					/>
				</Layout >
			)}

			{(dispFlg == '1' && shop != '' && shop != undefined && user != '' && user != undefined) &&(
				<Layout headerText="店舗営業時間管理(曜日別一括) -登録-" _dbconn={dbconn} _user={user}>
					<ShopTimeAddForm
						history={history}
						user={user}
						shop={shop}
						data={data}
						dbconn={dbconn}
						pra_shoptime={shoptime}
						pra_weektime={weektime}
						pra_interval={interval}
						pra_limit={limit}
						pra_weekcnt={weekcnt}
						submitReturn={onSubmitMoveListDisp}
					/>
				</Layout>
			)}
		</>
	);

}

export default ShopTime;